import {
  ALL_GRADES_LABEL,
  ALL_YEARS_LABEL,
  AU_ALL_YEARS_VALUES,
  GRADE_K_12_EXPANDED_GRADES,
  GRADE_K_12_VALUE,
} from "../constants";
import { ContentType, User } from "../types";
import AnxietyIcon from "src/assets/theme/Anxiety.svg?react";
import BelongingIcon from "src/assets/theme/Belonging.svg?react";
import BoundariesIcon from "src/assets/theme/Boundaries.svg?react";
import BrainBreaksIcon from "src/assets/theme/Brain Breaks.svg?react";
import WellbeingFoundationIcon from "src/assets/theme/WellbeingFoundations.svg?react";
import BuildingCommunityIcon from "src/assets/theme/Building Community.svg?react";
import FeelingIcon from "src/assets/theme/Feeling.svg?react";
import EmpowermentIcon from "src/assets/theme/Empowerment.svg?react";
import ExpressingMyselfIcon from "src/assets/theme/Expressing Myself.svg?react";
import FriendshipIcon from "src/assets/theme/Friendship.svg?react";
import HelpMyselfIcon from "src/assets/theme/Helping Myself.svg?react";
import IdentityIcon from "src/assets/theme/Identity.svg?react";
import LeadershipIcon from "src/assets/theme/Leadership.svg?react";
import MakingChoicesIcon from "src/assets/theme/Making Choices.svg?react";
import ManagingChangeIcon from "src/assets/theme/Managing Change.svg?react";
import NormsExpectationsIcon from "src/assets/theme/Norms & Expectations.svg?react";
import PeerDynamicsIcon from "src/assets/theme/Peer Dynamics.svg?react";
import PeerInfluenceIcon from "src/assets/theme/Peer Influence.svg?react";
import PeerSupportIcon from "src/assets/theme/Peer Support.svg?react";
import PersonalAccountabilityIcon from "src/assets/theme/Personal Accountability.svg?react";
import PersonalAutonomyIcon from "src/assets/theme/Personal Autonomy.svg?react";
import PersonalStrugglesIcon from "src/assets/theme/Personal Struggles.svg?react";
import PositiveThinkingIcon from "src/assets/theme/Positive Thinking.svg?react";
import PressureIcon from "src/assets/theme/Pressure.svg?react";
import ProblemSolvingIcon from "src/assets/theme/Problem-Solving.svg?react";
import RelationshipsIcon from "src/assets/theme/Relationships.svg?react";
import RespectIcon from "src/assets/theme/Respect.svg?react";
import RespectfulChoicesIcon from "src/assets/theme/Respectful Choices.svg?react";
import ResponsibilityIcon from "src/assets/theme/Responsibility.svg?react";
import SelfEsteemIcon from "src/assets/theme/Self-Esteem.svg?react";
import SelfWorthIcon from "src/assets/theme/Self-Worth.svg?react";
import SettingLimitsIcon from "src/assets/theme/Setting Limits.svg?react";
import StressIcon from "src/assets/theme/Stress.svg?react";
import SupportIcon from "src/assets/theme/Support.svg?react";
import SupportingMyselfIcon from "src/assets/theme/Supporting Myself.svg?react";
import ThefutureIcon from "src/assets/theme/The future.svg?react";
import TransitionsIcon from "src/assets/theme/Transitions.svg?react";
import UnderstandingMyselfIcon from "src/assets/theme/Understanding Myself.svg?react";
import WorriesIcon from "src/assets/theme/Worries.svg?react";

import KinderIcon from "src/assets/icons/kindergarten.svg?react";
import Grade1 from "src/assets/icons/grade-1.svg?react";
import Grade2 from "src/assets/icons/grade-2.svg?react";
import Grade3 from "src/assets/icons/grade-3.svg?react";
import Grade4 from "src/assets/icons/grade-4.svg?react";
import Grade5 from "src/assets/icons/grade-5.svg?react";
import Grade6 from "src/assets/icons/grade-6.svg?react";
import Grade7 from "src/assets/icons/grade-7.svg?react";
import Grade8 from "src/assets/icons/grade-8.svg?react";
import Grade9 from "src/assets/icons/grade-9.svg?react";
import Grade10 from "src/assets/icons/grade-10.svg?react";
import Grade11 from "src/assets/icons/grade-11.svg?react";
import Grade12 from "src/assets/icons/grade-12.svg?react";

import IconPDF from "@src/assets/icons/content_progress_pdf.svg?react";
import IconAudio from "@src/assets/icons/content_progress_audio.svg?react";
import IconSlide from "@src/assets/icons/content_progress_slide.svg?react";
import IconVideo from "@src/assets/icons/content_progress_video.svg?react";
import IconForm from "@src/assets/icons/content_progress_feedback.svg?react";

export const SupportedCountryNames = {
  US: "United States",
  AU: "Australia",
  CA: "Canada",
};

const AusGradeIcons = {
  "pre-k": KinderIcon,
  kindy: KinderIcon,
  "year 1": Grade1,
  "year 2": Grade2,
  "year 3": Grade3,
  "year 4": Grade4,
  "year 5": Grade5,
  "year 6": Grade6,
  "year 7": Grade7,
  "year 8": Grade8,
  "year 9": Grade9,
  "year 10": Grade10,
  "year 11": Grade11,
  "year 12": Grade12,
};

const GradeIcons = {
  "pre-k": KinderIcon,
  kindergarten: KinderIcon,
  "grade 1": Grade1,
  "grade 2": Grade2,
  "grade 3": Grade3,
  "grade 4": Grade4,
  "grade 5": Grade5,
  "grade 6": Grade6,
  "grade 7": Grade7,
  "grade 8": Grade8,
  "grade 9": Grade9,
  "grade 10": Grade10,
  "grade 11": Grade11,
  "grade 12": Grade12,
};
type SupportedCountry = keyof typeof SupportedCountryNames;

export const toTitleCase = (value: string) => {
  return value.replace(/\w\S*/g, (txt) => {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const isRichText = (value: any) =>
  value?.richText && Array.isArray(value.richText);

export const cleanRichText = (value: any) =>
  value.richText.map((item: any) => item.text).join("");

export const isOdd = (n: number) => {
  if (!n) return false;
  return Math.abs(n % 2) === 1;
};

export const getCountryNameFromUserId = (id: string): string => {
  const firstTwoCharacter: unknown = id.substring(0, 2);
  return SupportedCountryNames[firstTwoCharacter as SupportedCountry] || "";
};

export function filterUsers(users: User[], search: string) {
  const searchArr = (search ?? "").split(" ").map((s) => s.trim());
  let response = users;

  function filter(search: string, arr: User[]) {
    const s = search.toLowerCase();
    return arr.filter((c: User, index) => {
      if (c && c.firstName && c.firstName.toLowerCase().includes(s))
        return true;
      if (c && c.lastName && c.lastName.toLowerCase().includes(s)) return true;
      if (c && c.email && c.email.toLowerCase().includes(s)) return true;
      if (
        c &&
        c.customer &&
        c.customer.name &&
        (c.customer.name ?? "").toLowerCase().includes(s)
      )
        return true;
      const schools = (c.schools ?? []).map((s) =>
        (s?.name ?? "").toLowerCase(),
      );
      return schools.some((school) => school.includes(s));
    });
  }

  searchArr.forEach((search) => {
    response = filter(search, response);
  });

  return response;
}

export const toBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  if (value === null || value === undefined) return false;
  return true;
}

export const sleep = async (ms: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

function sortByPosition(
  a: { position?: number | null } | null,
  b: { position?: number | null } | null,
) {
  return (a?.position ?? 10000) - (b?.position ?? 0);
}

function sortByNumber(
  a: { number?: number | null } | null,
  b: { number?: number | null } | null,
) {
  return (a?.number ?? 10000) - (b?.number ?? 0);
}

export const truncateEmail = (email: string): string => {
  const [emailFirst, emailDomain] = email.split("@");
  return `${emailFirst.trim().substring(0, 2)}...@${emailDomain}`;
};

export { notEmpty, sortByPosition, sortByNumber };

export const generateNonce = () => {
  const randomValues = window.crypto.getRandomValues(new Int16Array(1));
  return String(Math.abs(randomValues[0]));
};

export function sortByAlphabetic(a: { name: string }, b: { name: string }) {
  if (a.name < b.name) return -1;
  if (a.name > b.name) return 1;
  return 0;
}

export const getThemeIconByTitle = (title: string) => {
  switch (title) {
    case "Belonging":
      return BelongingIcon;
    case "Feeling":
      return FeelingIcon;
    case "Helping Myself":
      return HelpMyselfIcon;
    case "Building Community":
      return BuildingCommunityIcon;
    case "Anxiety":
      return AnxietyIcon;
    case "Boundaries":
      return BoundariesIcon;
    case "Wellbeing Foundations":
      return WellbeingFoundationIcon;
    case "Empowerment":
      return EmpowermentIcon;
    case "Expressing Myself":
      return ExpressingMyselfIcon;
    case "Friendship":
      return FriendshipIcon;
    case "Identity":
      return IdentityIcon;
    case "Leadership":
      return LeadershipIcon;
    case "Making Choices":
      return MakingChoicesIcon;
    case "Managing Change":
      return ManagingChangeIcon;
    case "Norms & Expectations":
      return NormsExpectationsIcon;
    case "Peer Dynamics":
      return PeerDynamicsIcon;
    case "Peer Influence":
      return PeerInfluenceIcon;
    case "Peer Support":
      return PeerSupportIcon;
    case "Personal Accountability":
      return PersonalAccountabilityIcon;
    case "Personal Autonomy":
      return PersonalAutonomyIcon;
    case "Personal Struggles":
      return PersonalStrugglesIcon;
    case "Positive Thinking":
      return PositiveThinkingIcon;
    case "Pressure":
      return PressureIcon;
    case "Problem-Solving":
      return ProblemSolvingIcon;
    case "Relationships":
      return RelationshipsIcon;
    case "Respect":
      return RespectIcon;
    case "Respectful Choices":
      return RespectfulChoicesIcon;
    case "Responsibility":
      return ResponsibilityIcon;
    case "Self-Esteem":
      return SelfEsteemIcon;
    case "Self-Worth":
      return SelfWorthIcon;
    case "Setting Limits":
      return SettingLimitsIcon;
    case "Stress":
      return StressIcon;
    case "Support":
      return SupportIcon;
    case "Supporting Myself":
      return SupportingMyselfIcon;
    case "The Future":
      return ThefutureIcon;
    case "Transitions":
      return TransitionsIcon;
    case "Understanding Myself":
      return UnderstandingMyselfIcon;
    case "Worries":
      return WorriesIcon;
    case "Brain Breaks":
      return BrainBreaksIcon;
    default: {
      return FeelingIcon;
    }
  }
};

export const getIconByTitle = (title: string) => {
  const regex = /\b(?:Grade \d+|Pre-k|Kindergarten)\b/i;
  const match = title.match(regex);
  if (match) return GradeIcons[match[0].toLocaleLowerCase()];
  return KinderIcon;
};

export const getAusIconByTitle = (title: string) => {
  const regex = /\b(?:Year \d+|Pre-k|Kindy)\b/i;
  const match = title.match(regex);
  if (match) return AusGradeIcons[match[0].toLocaleLowerCase()];
  return KinderIcon;
};

function checkRepeat(array: any[], el: string) {
  for (var i = 0; i < array.length; i++) if (array[i].color === el) return true;
  return false;
}

export function getRandColor(courses: any[], array: string[]) {
  var rand = array[Math.floor(Math.random() * array.length)];
  if (!checkRepeat(courses, rand)) {
    return rand;
  }
  return getRandColor(courses, array);
}

// Debounce function
export function debounce<T extends (...args: any[]) => void>(
  func: T,
  wait: number,
) {
  let timeout: ReturnType<typeof setTimeout>;
  return function (...args: Parameters<T>) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export function expandGradeLevel(gradeLevel: any) {
  const rangePattern = /^Grade\s*(\d+)\s*-\s*(\d+)$/;
  let grades: string[] = [];
  const match = gradeLevel.match(rangePattern);
  if (match) {
    const startGrade = parseInt(match[1], 10);
    const endGrade = parseInt(match[2], 10);
    for (let i = startGrade; i <= endGrade; i++) {
      grades.push(`Grade ${i}`);
    }
  } else {
    if (gradeLevel === "Grade K-3") {
      grades = ["Pre-K", "Kindergarten", "Grade 1", "Grade 2", "Grade 3"];
    } else if (gradeLevel === GRADE_K_12_VALUE) {
      grades = [...GRADE_K_12_EXPANDED_GRADES];
    } else {
      grades.push(gradeLevel);
    }
  }
  return grades;
}

function sortedGradesMatch(a: string[], b: string[]) {
  if (a.length !== b.length) return false;
  const sortedA = [...a].sort();
  const sortedB = [...b].sort();
  return sortedA.every((grade, index) => grade === sortedB[index]);
}

export function expandGradeLevelsForApi(grades: string[]) {
  if (!grades.includes(GRADE_K_12_VALUE)) {
    return grades;
  }
  const withoutK12 = grades.filter((grade) => grade !== GRADE_K_12_VALUE);
  return [...new Set([...GRADE_K_12_EXPANDED_GRADES, ...withoutK12])];
}

export function collapseGradeLevelsForDisplay(grades: string[]) {
  if (sortedGradesMatch(grades, GRADE_K_12_EXPANDED_GRADES)) {
    return [GRADE_K_12_VALUE];
  }
  return grades;
}

export function serializeGradeLevelForApi(gradeLevel?: string | null) {
  if (!gradeLevel) {
    return gradeLevel ?? undefined;
  }
  try {
    const parsed = JSON.parse(gradeLevel) as string[];
    if (!Array.isArray(parsed)) {
      return gradeLevel;
    }
    const expanded = expandGradeLevelsForApi(parsed);
    return expanded.length ? JSON.stringify(expanded) : "";
  } catch {
    return gradeLevel;
  }
}

const AU_AGE_GROUP_EXPANSIONS: Record<string, string[]> = {
  "Kindy/Reception - Year 2": ["Kindy/Reception", "Year 1", "Year 2"],
  "Year 3-4": ["Year 3", "Year 4"],
  "Year 5-6": ["Year 5", "Year 6"],
  "Year 7-8": ["Year 7", "Year 8"],
  "Year 9-12": ["Year 9", "Year 10", "Year 11", "Year 12"],
  "Year 4-12": [
    "Year 4",
    "Year 5",
    "Year 6",
    "Year 7",
    "Year 8",
    "Year 9",
    "Year 10",
    "Year 11",
    "Year 12",
  ],
};

function numberToWord(number: number) {
  const ones = [
    "Zero",
    "One",
    "Two",
    "Three",
    "Four",
    "Five",
    "Six",
    "Seven",
    "Eight",
    "Nine",
  ];
  const teens = [
    "Ten",
    "Eleven",
    "Twelve",
    "Thirteen",
    "Fourteen",
    "Fifteen",
    "Sixteen",
    "Seventeen",
    "Eighteen",
    "Nineteen",
  ];

  if (number < 0 || number > 99) {
    return "Number out of range";
  }

  if (number < 10) {
    return ones[number];
  }

  if (number < 20) {
    return teens[number - 10];
  }

  return `${number}`;
}

function getGradeSortValue(grade: string) {
  if (grade === "Pre-K") return -1;
  if (grade === "Kindergarten") return 0;
  const gradeMatch = grade.match(/Grade (\d+)/);
  if (gradeMatch) return parseInt(gradeMatch[1], 10);
  return Infinity;
}

export function parseAgeGroupValues(ageGroup?: string | null) {
  if (!ageGroup) return [];

  if (ageGroup.includes("[")) {
    try {
      const parsed = JSON.parse(ageGroup) as string[];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  return [ageGroup];
}

export function expandAustraliaAgeGroups(ageGroups: string[]) {
  const expanded: string[] = [];

  ageGroups.forEach((item) => {
    const mapped = AU_AGE_GROUP_EXPANSIONS[item];
    if (mapped) {
      expanded.push(...mapped);
    } else {
      expanded.push(item);
    }
  });

  return [...new Set(expanded)];
}

function formatYearLabel(item: string) {
  if (item.includes("Kindy")) return item;

  const tmp = item.replace("Year ", "");
  if (item.includes("-")) {
    const [start, end] = tmp.split("-");
    return `${numberToWord(Number(start))}-${numberToWord(Number(end))}`;
  }

  return numberToWord(Number(tmp));
}

export function formatLessonGradeDisplay(gradeLevel?: string | null) {
  if (!gradeLevel) return "";

  try {
    const grades = JSON.parse(gradeLevel) as string[];
    if (!Array.isArray(grades)) return "";

    const expanded = expandGradeLevelsForApi(grades);
    if (sortedGradesMatch(expanded, GRADE_K_12_EXPANDED_GRADES)) {
      return ALL_GRADES_LABEL;
    }

    return [...expanded]
      .sort((a, b) => getGradeSortValue(a) - getGradeSortValue(b))
      .map((grade) => {
        if (grade.includes("Grade ")) {
          return numberToWord(Number(grade.replace("Grade ", "")));
        }
        return grade;
      })
      .join(", ");
  } catch {
    return "";
  }
}

export function formatLessonYearDisplay(ageGroup?: string | null) {
  const items = parseAgeGroupValues(ageGroup);
  if (!items.length) return "";

  const expanded = expandAustraliaAgeGroups(items);
  if (sortedGradesMatch(expanded, AU_ALL_YEARS_VALUES)) {
    return ALL_YEARS_LABEL;
  }

  return items.map(formatYearLabel).join(", ");
}

export const getContentIcon = (type: ContentType) => {
  switch (type) {
    case ContentType.PDF: {
      return IconPDF;
    }
    case ContentType.AUDIO: {
      return IconAudio;
    }
    // case ContentType.GOOGLESLIDE:
    case ContentType.SLIDE: {
      return IconSlide;
    }
    case ContentType.REVEALSLIDE:
    case ContentType.ZIPSLIDE: {
      return IconSlide;
    }
    case ContentType.VIDEO: {
      return IconVideo;
    }
    case ContentType.FORM: {
      return IconForm;
    }
    default: {
      return null;
    }
  }
};

export const hasArrayValues = <T>(e: T) =>
  Boolean(Array.isArray(e) && e.length > 0);

export const resetGoogleTranslateWidget = () => {
  const bannerIframe = document.querySelector(
    "iframe.skiptranslate",
  ) as HTMLIFrameElement | null;

  if (bannerIframe && bannerIframe.contentDocument) {
    const bannerDoc = bannerIframe.contentDocument;

    const closeWidget = bannerDoc.getElementById(
      ":0.close",
    ) as HTMLAnchorElement | null;
    if (closeWidget) {
      closeWidget.click();
    }
    const closeButton = bannerDoc.getElementById(
      ":1.close",
    ) as HTMLAnchorElement | null;
    if (closeButton) {
      closeButton.click();
    }
  }
};

export const generateSlug = (programName: string) =>
  programName.toLowerCase().replace(/\s+/g, "");

export const isFilePath = (string: string) => /\.\w+$/.test(string);

export const isValidUrl = (string: string) => {
  try {
    new URL(string);
    return true;
  } catch (error) {
    return false;
  }
};
